import CameraOutlined from '@ant-design/icons/CameraOutlined'
import { CantileverButton } from 'components/CantileverButton'
import React, { useRef } from 'react'

interface ImageUploadButtonProps {
  handleImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
  handleImageUpload,
  disabled = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  return (
    <div>
      <input
        type='file'
        accept='image/*'
        onChange={handleImageUpload}
        style={{ display: 'none' }}
        ref={fileInputRef}
        id='image-upload'
        multiple
      />
      <CantileverButton
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled}
        style={{ gap: '8px', border: '1px solid #444' }}>
        Upload Image
        <CameraOutlined />
      </CantileverButton>
    </div>
  )
}
